import { render } from "./PlaceSection.vue?vue&type=template&id=5c77c898"
import script from "./PlaceSection.vue?vue&type=script&lang=js"
export * from "./PlaceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__